import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { font } from '@styles/fonts';
import { SimpleOnPress } from '@interfaces/base';
import { DashboardScope } from '@api/domain/types';
import type { MachineDashboardResult } from '@api/domain/types';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import type { Rank, RankBadgeVariant, WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import DashboardOverviewBottomBlockRowBadge from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowBadge';
import DashboardOverviewBottomBlockRowValue from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowValue';
import DashboardRowWrapper from '@v2/pages/dashboard/common/components/DashboardRowWrapper';

interface DashboardOverviewBottomBlockMachineRowProps
  extends WithColor,
    SimpleOnPress,
    WithBorderRadiusConfig,
    Pick<MachineDashboardResult, 'shortName' | 'fullName' | 'machineId' | 'totalTimeTotalInSeconds'> {
  rank: Rank;
  variant: RankBadgeVariant;
}

const DashboardOverviewBottomBlockMachineRow: FC<DashboardOverviewBottomBlockMachineRowProps> = ({
  C,
  rank,
  variant,
  shortName,
  fullName,
  totalTimeTotalInSeconds,
  onPress,
  borderRadiusConfig,
}) => {
  const label = shortName ?? fullName ?? '';

  return (
    <DashboardRowWrapper onPress={onPress} testID={TEST_IDS.dashboardOverviewBottomBlock.row(variant, rank)} scope={DashboardScope.Machine} borderRadiusConfig={borderRadiusConfig}>
      <DashboardOverviewBottomBlockRowBadge rank={rank} variant={variant} />
      <View style={{ flex: 1 }}>
        <Text style={[font['Subhead 1 bold'], { color: C('Label/Light/Primary') }]} numberOfLines={1}>
          {label}
        </Text>
      </View>
      <DashboardOverviewBottomBlockRowValue seconds={totalTimeTotalInSeconds ?? 0} variant={variant} />
    </DashboardRowWrapper>
  );
};

export default ColorWrapper(DashboardOverviewBottomBlockMachineRow);
